export const SpecsFieldLabels: Record<string, string> = {
  material: "Material",
  thickness: "Thickness",
  backingLiner: "Backing Liner",
  adhesive: "Adhesive",
  protectiveFinish: "Protective Finish",
  waterResistant: "Water Resistant",
  outdoorDurability: "Outdoor Durability",
  surfaceWearResistance: "Surface Wear Resistance",
  uvResistant: "UV Resistant",
  oilResistant: "Oil Resistant",
  writable: "Writable",
  careCleaning: "Care & Cleaning",
  temperatureTolerance: "Temperature Tolerance",
  inkType: "Ink Type",
  skinSafety: "Skin Safety",
  wearDuration: "Wear Duration",
  applicationMethod: "Application Method",
  removalMethod: "Removal Method",
  colorLimitations: "Color Limitations",
  notes: "Notes",
};
